export { default as UiTabPanel } from "./UiTabPanel";
